import { createRouter, createWebHashHistory } from 'vue-router'
import RoundedCornerView from '../views/RoundedCornerView.vue'

// 使用 hash 路由，挂在 /imgtool2/ 下，避免与主应用 history 路由冲突
const router = createRouter({
  history: createWebHashHistory('/imgtool2/'),
  routes: [
    {
      path: '/',
      name: 'rounded-corner',
      component: RoundedCornerView,
    },
    {
      path: '/crop',
      name: 'crop',
      component: () => import('../views/CropView.vue'),
    },
    {
      path: '/height-crop',
      name: 'height-crop',
      component: () => import('../views/HeightCropView.vue'),
    },
    {
      path: '/convert',
      name: 'convert',
      component: () => import('../views/ConvertView.vue'),
    },
    {
      path: '/compress',
      name: 'compress',
      component: () => import('../views/CompressView.vue'),
    },
    {
      path: '/favicon',
      name: 'favicon',
      component: () => import('../views/FaviconView.vue'),
    },
  ],
})

export default router
